import { EUserType, UserTypeUtil } from '../#common';

export interface User {
  userId: string;

  nickName: string;

  linkName: string;

  userType: EUserType;

  description: string;

  avatar: string;

  publishCount: number;

  fansCount: number;

  authInfo: any;
}

export const LegacyUserUtil = {
  getPath: (user: User): string => {
    return `/${UserTypeUtil.getLinkNamePrefix(user.userType)}${user.linkName}`;
  },
};
